/* Native GET forms remain functional when JS or predictive search is unavailable. */
(() => {
  if (!customElements.get('bc-search')) {
    class BlancsSearch extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.input = this.querySelector('input[type="search"]');
        this.panel = this.querySelector('.bc-search-results');
        this.results = this.querySelector('[data-results]');
        this.status = this.querySelector('[data-search-status]');
        this.version = 0;
        this.events = new AbortController();
        const signal = this.events.signal;
        this.input.addEventListener('input', () => {
          clearTimeout(this.timer);
          this.version++;
          this.request?.abort();
          this.close();
          if (this.input.value.trim().length < 2) return;
          this.timer = setTimeout(() => this.suggest(), 220);
        }, {signal});
        this.input.addEventListener('focus', () => {
          if (this.input.value.trim().length > 1) this.suggest();
        }, {signal});
        this.input.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown' && !this.panel.hidden) {
            const first = this.results.querySelector('a');
            if (first) { event.preventDefault(); first.focus(); }
          }
        }, {signal});
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            this.cancel();
            // Focus before closing: focus handler may request; cancel it again.
            this.input.focus();
            this.cancel();
          }
        }, {signal});
        this.querySelector('.bc-search-close').addEventListener('click', () => {
          this.input.focus(); this.cancel();
        }, {signal});
        // Keep mouse clicks on suggestions from blurring the input before click.
        // Native link navigation (including modifier clicks) remains untouched.
        this.panel.addEventListener('mousedown', event => {
          if (event.button === 0 && event.target.closest('a[href]')) event.preventDefault();
        }, {signal});
        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.cancel();
        }, {signal});
        // Some browsers do not focus links on click. Close on the next outside
        // focus instead of removing the clicked link between mouse down and up.
        document.addEventListener('focusin', event => {
          if (!this.contains(event.target)) this.cancel();
        }, {signal});
        document.addEventListener('pointerdown', e => { if (!this.contains(e.target)) this.cancel(); }, {signal});
      }
      close() { this.panel.hidden = true; this.input.setAttribute('aria-expanded', 'false'); }
      cancel() { clearTimeout(this.timer); this.version++; this.request?.abort(); this.close(); }
      async suggest() {
        const query = this.input.value.trim();
        if (query.length < 2) return;
        this.request?.abort();
        this.request = new AbortController();
        const version = ++this.version;
        this.status.textContent = 'Searching products';
        try {
          const url = new URL(this.dataset.suggestUrl, location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '5');
          url.searchParams.set('section_id', 'bc-predictive-search');
          const response = await fetch(url, {signal:this.request.signal});
          if (!response.ok) throw new Error('Search unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = doc.querySelector('[data-predictive-content]');
          if (!content) throw new Error('Missing results');
          if (version !== this.version || !this.contains(document.activeElement)) return;
          this.results.replaceChildren(content);
          this.panel.hidden = false;
          this.input.setAttribute('aria-expanded', 'true');
          const count = content.querySelectorAll('.bc-prediction-list li').length;
          this.status.textContent = count ? `${count} product suggestions. Press the down arrow or Tab to explore.` : 'No product suggestions. Press Enter for full search results.';
        } catch (error) {
          if (error.name === 'AbortError' || version !== this.version) return;
          this.close();
          this.status.textContent = 'Press Enter to search all products.';
        }
      }
      disconnectedCallback() { this.cancel(); this.events?.abort(); this.ready = false; }
    }
    customElements.define('bc-search', BlancsSearch);
  }
  function initializeNavigation(root = document) {
    root.querySelectorAll('[data-bc-header]').forEach(header => {
      if (header.dataset.initialized) return;
      header.dataset.initialized = 'true';
      const toggle = header.querySelector('.search-toggle');
      const searchArea = header.querySelector('.bc-header-search');
      if (toggle && searchArea) {
        toggle.hidden = false; searchArea.hidden = true;
        toggle.addEventListener('click', () => {
          searchArea.hidden = !searchArea.hidden;
          toggle.setAttribute('aria-expanded', String(!searchArea.hidden));
          if (!searchArea.hidden) searchArea.querySelector('input[type=search]').focus();
        });
      }
      header.addEventListener('toggle', event => {
        const current = event.target;
        if (!current.matches('.bc-nav-disclosure') || !current.open) return;
        header.querySelectorAll('.bc-nav-disclosure[open]').forEach(other => { if (other !== current) other.open = false; });
      }, true);
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        header.querySelectorAll('.bc-nav-disclosure[open]').forEach(details => { details.open = false; details.querySelector('summary').focus(); });
      });
      // Clicking a link can blur the summary without focusing the link (Safari).
      // Closing on focusout would hide the link before its click can navigate.
      // Only dismiss after focus actually moves to an element outside the header.
      document.addEventListener('focusin', event => {
        if (!header.contains(event.target)) header.querySelectorAll('.bc-nav-disclosure[open]').forEach(d => { d.open = false; });
      });
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('.bc-nav-disclosure[open]').forEach(d => { if (!d.contains(event.target)) d.open = false; });
  });
  initializeNavigation();
  document.addEventListener('shopify:section:load', event => initializeNavigation(event.target));
})();

(() => { const header=document.querySelector('[data-bc-header]'); if(!header)return; const update=()=>header.classList.toggle('bc-scrolled',window.scrollY>32); update(); window.addEventListener('scroll',update,{passive:true}); })();
